import React from "react";
import MetaElement from "../../components/elements/MetaElement";
import WithdrawalForm from "../../components-v2/withdrawal/WithdrawalForm";

const RetragereContract = () => {
  return (
    <>
      <MetaElement pageId="info/retragere-contract" />
      <WithdrawalForm />
    </>
  );
};

export default RetragereContract;
